var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextSizeSetting20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6414 6.41021C13.4575 5.90073 14.3998 5.646 15.4682 5.646C17.4468 5.646 18.436 6.68473 18.436 8.7622V14.0449H16.9967V12.7762H16.9596C16.3907 13.7506 15.5523 14.2378 14.4443 14.2378C13.648 14.2378 13.0148 14.0226 12.5449 13.5923C12.075 13.162 11.8401 12.5808 11.8401 11.8487C11.8401 10.3154 12.7477 9.42253 14.5631 9.17027L16.9967 8.82897C16.9967 7.48851 16.4427 6.81828 15.3347 6.81828C14.3504 6.81828 13.4526 7.14969 12.6414 7.8125V6.41021ZM15.075 10.1867C14.4023 10.2758 13.9373 10.444 13.6801 10.6913C13.4279 10.9386 13.3017 11.2848 13.3017 11.73C13.3017 12.1208 13.4402 12.4398 13.7172 12.6871C13.9942 12.9344 14.3603 13.0581 14.8153 13.0581C15.4485 13.0581 15.9703 12.8355 16.3808 12.3903C16.7914 11.9452 16.9967 11.3862 16.9967 10.7135V9.92706L15.075 10.1867Z",
    fill: "#222627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9646 14.0448H9.32493L8.15265 10.899H3.36705L2.26154 14.0448H0.621826L4.99935 2.552H6.58712L10.9646 14.0448ZM7.69263 9.60055L5.95647 4.82238C5.90206 4.66904 5.8427 4.40194 5.7784 4.02107H5.7413C5.68689 4.36731 5.62506 4.63442 5.55581 4.82238L3.83448 9.60055H7.69263Z",
    fill: "#222627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.50293 17.448H19.4969",
    stroke: "#222627",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSizeSetting20);
export default __webpack_public_path__ + "static/media/text-size-setting_20.c8cad2491a1735f172e1c9cc587fb66f.svg";
export { ForwardRef as ReactComponent };